import { useSelector } from 'react-redux';
import { UserRoles } from 'src/constants';
import { RootState } from 'src/redux/reducers/rootReducer';

export const useUserRole = () => {
  const auth = useSelector((state: RootState) => state.auth);

  const isSuperAdmin =
    auth.userDefault?.roles?.includes(UserRoles.SuperAdmin) || false;

  const isAdmin = auth.user?.roles?.join('').includes(UserRoles.Admin) || false;

  const isMaker = auth.user?.roles?.join('').includes(UserRoles.Maker) || false;

  const isApprover =
    auth.user?.roles?.join('').includes(UserRoles.Approver) || false;

  return { isSuperAdmin, isAdmin, isMaker, isApprover };
};
